import axios from "../api/axios";
import { endpoints } from "../api/endpoint";
import { useQuery } from "@tanstack/react-query";

const getListOfLeadIds = async () => {
  const response = await axios.get(endpoints.getDriverLeadIds);
  return response.data?.data || [];
};

export function useLeadIdList(options = {}) {
  return useQuery({
    queryKey: ["lead-ids"],
    queryFn: getListOfLeadIds,
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
    retry: 1,
    enabled: options?.enabled ?? true,
    ...options,
  });
}
